import { useEffect, useState } from 'react'
import CreditsTable from '../../components/admin/credits/CreditsTable'
import Header from '../../components/admin/credits/Header'
import styles from './Credits.module.css'
import api from '../../utils/api'

const Credits = () => {
  const [data, setData] = useState([])
  const [editId, setEditId] = useState(null)
  const [savingId, setSavingId] = useState(null)

  useEffect(() => {
    const fetchLicenses = async () => {
      try {
        const { data } = await api.get(`licenses`)
        setData(data.sort((a, b) => a.id - b.id))
      } catch (error) {
        console.log('Error fetching licenses:', error)
      }
    }

    fetchLicenses()
  }, [])

  const handleEdit = (id) => {
    setEditId(id)
  }

  const handleSave = async (id, newData) => {
    setSavingId(id)
    try {
      await api.put(`licenses/${id}`, newData)
      setData((prev) => prev.map((row) => (row.id === id ? { ...row, ...newData } : row)))
    } catch (error) {
      console.log('Error updating license:', error)
    }
    setSavingId(null)
    setEditId(null)
  }

  const handleCancel = () => {
    if (savingId) return // Prevent cancel during save
    setEditId(null)
  }
  return (
    <div className={styles.container}>
      <Header />
      <div className={styles.tableContainer}>
        <CreditsTable editId={editId} savingId={savingId} data={data} handleEdit={handleEdit} handleSave={handleSave} handleCancel={handleCancel} />
      </div>
    </div>
  )
}
export default Credits
